<template lang="pug">
.rights-backdrop(v-if="visible")
  .rights-modal
    .rights-header
      span 恭喜获得{{ data.couponCount }}张优惠券
    .rights-body
      .rights-item(v-for="item in data.couponPackages") {{ item.name }}
    .rights-footer
      img.footer-bg(src="@/assets/member/BG_quan2@2x.png")
      .btn(@click="handleClick") 下载APP立即使用
      img.close(
        @click="handleClose"
        src="@/assets/member/x@2x.png"
      )

</template>

<script>
import { Native } from '@hb/NBridge/lib/h5';
import { appTask } from '../store';

export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      if (appTask.xcxActionUrl) {
        Native.callNative({
          method: 'goOperationUrl',
          params: appTask.xcxActionUrl,
        });
      }
    },
    handleClose() {
      this.$emit('update:visible', false);
    },
  },
};
</script>

<style lang="less" scoped>
.rights-backdrop {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.49);
}

.rights-modal {
  position: absolute;
  right: 0;
  left: 0;
  margin: 1rem auto 0;
  width: 3rem;
  height: 3.7rem;
  background-image: url('~@/assets/member/BG_quan1@2x.png');
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  border-radius: 12px;

  .rights-header {
    padding: 0.2rem 0 0.15rem 0;
    text-align: center;
    font-size: 18px;
    font-weight: 400;
    color: #fff;
  }

  .rights-body {
    padding: 0 0.2rem 0.9rem;
    flex: 1;
    overflow-y: auto;

    .rights-item {
      color: #333;
      font-size: 14px;
      line-height: 0.6rem;
      padding: 0 0.12rem;
      background-image: url('~@/assets/member/BG_youhuiquan@2x.png');
      border-radius: 6px;
      margin-bottom: 0.1rem;
    }
  }

  .rights-footer {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    text-align: center;
    height: 1.05rem;

    .footer-bg {
      position: absolute;
      z-index: 0;
      height: 100%;
      width: 100%;
      border-bottom-left-radius: 12px;
      border-bottom-right-radius: 12px;
    }

    .btn {
      position: absolute;
      bottom: 0.15rem;
      background: linear-gradient(180deg, rgba(255, 232, 17, 1) 0%, rgba(255, 205, 7, 1) 100%);
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
      border-radius: 6px;
      font-size: 16px;
      font-weight: 500;
      line-height: 0.46rem;
      height: 0.46rem;
      width: 2.7rem;
      text-align: center;
      z-index: 1;
      color: #940000;
    }

    .close {
      position: absolute;
      z-index: 3;
      top: 100%;
      left: 0;
      right: 0;
      margin: 0.2rem auto 0;
      width: 0.32rem;
      height: 0.32rem;
    }
  }
}
</style>
